import { useSessionStorageState } from "ahooks";
import queryString, { ParsedQuery } from "query-string";
import { useEffect } from "react";



export function useRedirectUrl(defaultUrl = "/") {
  const [redirect, setRedirectStorage] = useSessionStorageState<string>("_redirect", defaultUrl);

  useEffect(() => {
    const query: ParsedQuery<string> = queryString.parse(
      window.location.search
    );
    if (query.redirect) {
      setRedirectStorage(query.redirect as string);
    }

    return () => {
      sessionStorage.removeItem("_redirect");
    };
  });

  return redirect;
}
